import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DynamictableComponent } from 'src/app/shared/dynamictable/dynamictable.component';
import { formatDate } from '@angular/common';
import { ApprovalDashBoardService } from "src/app/services/approval-dashboard/approval-dashboard.service"
import { BillingAdjustmentDetails, InvoiceDetails } from 'src/app/Models/invoiceDetails';
import { saveAs } from "file-saver";
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDateRangeInput, MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule, ErrorStateMatcher } from '@angular/material/core';
import { BillingAdjustmentStatusEnum, BillingAdjustmentStatusEnumDisplay, dateRangeValidator, FilterDto, formatDateforBAT } from 'src/utilities';
import { MatExpansionModule } from '@angular/material/expansion';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MsalService } from '@azure/msal-angular';
import { SharedModule } from 'src/app/shared/shared.module';
import { DigitalCopyPdfService } from "src/app/services/digital-copy-pdf/digital-copy-pdf.service";
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { NgxSpinnerModule } from "ngx-spinner";

// Error State Matcher for consistent error behavior
export class DateRangeErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    if (!control || !control.parent) return false;

    const isControlInvalid = control.invalid && control.touched;
    const parent = control.parent;

    const hasDateRangeInvalid = parent.hasError('dateRangeInvalid') && control.touched;
    const hasEndDateRequired = parent.hasError('endDateRequired') && control.touched;

    const isStartDate = control === parent.get('startDate');
    const isEndDate = control === parent.get('endDate');

    if (hasDateRangeInvalid && (isStartDate || isEndDate)) {
      return true;
    }

    if (hasEndDateRequired && isEndDate) {
      return true;
    }

    return isControlInvalid;
  }
}

@Component({
    selector: 'app-approval-history',
    templateUrl: './approval-history.component.html',
    styleUrl: './approval-history.component.scss',
    imports: [FormsModule, MatDatepickerModule, MatSelectModule, MatError, MatNativeDateModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, DynamictableComponent, MatTableModule, MatExpansionModule, SharedModule, NgxSpinnerModule]
})
export class ApprovalHistoryComponent {
  @ViewChild('template') template: TemplateRef<any>;
  @ViewChild(DynamictableComponent) dynamicTable: DynamictableComponent; // Reference to dynamic table for pagination control
    isGoodWillRequest: boolean = false;
    selectedData: any;
    dialogRef: any;
    respose : any;
    isLoader: boolean = true;
    displayedColumns = [
    {label: 'ADJ REQ ID#',propertyName: 'adjReqId',showLockIcon: (element: any) => element.isPRSOrConsolidated === true},
      { label: 'Billing Site', propertyName: 'billingSite' },
      { label: 'Request Date', propertyName: 'adjRequestDate' },
      { label: 'MMS#', propertyName: 'mms' },
      { label: 'Customer Name', propertyName: 'custName' },
      { label: 'Adj Request', propertyName: 'adjReq' },
      { label: 'Adj Reason', propertyName: 'adjReason' },
      { label: 'Adj details', propertyName: 'descriptionComment' },
       { label: 'AE', propertyName: 'ae' },
      { label: 'Requestor', propertyName: 'requestor' },
       { label: 'Approver', propertyName: 'approver' },
      { label: 'Adjst Net Amt', propertyName: 'adjNetAmount' },
      //{label:'Status', propertyName:'statusDesc'},
      { label: 'Check Refund Remarks', propertyName: 'checkRefundRemarks' },
      //{label: 'Remarks', propertyName: 'rejectionReason' },
      { label: 'Is PRS', propertyName: 'isPRS' },
      { label: 'Is Consolidated', propertyName: 'isConsolidated' },
      {
        label: 'Action', propertyName: 'icon', showSpinner: false,
        icons: [
          { toolTip: 'View Statement Details', icon: 'remove_red_eye', callFrom: 'view' },
          { toolTip: 'Download Files', icon: 'download', callFrom: 'download' },
          {
            toolTip: 'Digital Copy PDF',
            icon: 'picture_as_pdf',
            callFrom: 'digital-copy-pdf'
          }
        ]
      }
    ];

  /**
   * Download a digital copy PDF for the given adjReqId using the shared service
   */
  downloadDigitalCopy(adjReqId: string | number) {
    this.digitalCopyPdfService.downloadDigitalCopy(adjReqId);
  }
    
    invoiceDisplayedColumns = [
      { label: 'ADJ REQ ID#', propertyName: 'adjReqId' },
      { label: 'Customer Name', propertyName: 'customerName' },
      { label: 'Creation Time', propertyName: 'recordCreationTimestamp' },
      { label: 'CMF', propertyName: 'cmf' },
      { label: 'MMS', propertyName: 'mms' },
      { label: 'Orig Stmt', propertyName: 'origStmt' },
      { label: 'Invoice Date', propertyName: 'invDate' },
      { label: 'WE Period', propertyName: 'wePeriod' },
      { label: 'PCS', propertyName: 'pcs' },
      { label: 'F25DomMail Current', propertyName: 'f25DomMail_Current' },
      { label: 'D49Fsc Current', propertyName: 'd49Fsc_Current' },
      { label: 'D90MinFee Current', propertyName: 'd90MinFee_Current' },
      { label: '99Misc Current', propertyName: '_99Misc_Current' },
      { label: 'F03Intl Current', propertyName: 'f03Intl_Current' },
      { label: 'Total Invoice', propertyName: 'totalInvoice' },
      { label: 'FSCRate Billed', propertyName: 'fscRateBilled' },
      { label: 'Correct FSC', propertyName: 'correctFSC' },
      { label: 'F25DomMail New', propertyName: 'f25DomMail_New' },
      { label: 'D49Fsc New', propertyName: 'd49Fsc_New' },
      { label: 'D90MinFee New', propertyName: 'd90MinFee_New' },
      { label: '99Misc New', propertyName: '_99Misc_New' },
      { label: 'F03Intl New', propertyName: 'f03Intl_New' },
      { label: 'Total Correct Charges', propertyName: 'totalCorrectCharges' },
      { label: 'F25DomMail Adj', propertyName: 'f25DomMail_Adj' },
      { label: 'D49Fsc Adj', propertyName: 'd49Fsc_Adj' },
      { label: 'D90MinFee Adj', propertyName: 'd90MinFee_Adj' },
      { label: '99Misc Adj', propertyName: '_99Misc_Adj' },
      { label: 'F03Intl Adj', propertyName: 'f03Intl_Adj' },
      { label: 'Total Adjustment', propertyName: 'totalAdjustment' },
      { label: 'Action', propertyName: 'action' },
      {label : 'Billing Site', propertyName: 'billingSite'},
      {label : 'AE', propertyName: 'ae'},
      { label: 'Is PRS', propertyName: 'isPRS' },
      { label: 'Is Consolidated', propertyName: 'isConsolidated' }
    ];

    invoiceDisplayedGoodWillColumns = [
      { label: 'ADJ REQ ID#', propertyName: 'adjReqId' },
      { label: 'Customer Name', propertyName: 'customerName' },
      { label: 'Creation Time', propertyName: 'recordCreationTimestamp' },
      { label: 'CMF', propertyName: 'cmf' },
      { label: 'MMS', propertyName: 'mms' },
      { label: 'Net Adjustment', propertyName: 'totalAdjustment' },
      { label: 'Action', propertyName: 'action' },
      {label : 'Billing Site', propertyName: 'billingSite'},
      {label : 'AE', propertyName: 'ae'},
      { label: 'Is PRS', propertyName: 'isPRS' },
      { label: 'Is Consolidated', propertyName: 'isConsolidated' }
    ];
  
    invoiceDataSource = new MatTableDataSource<InvoiceDetails>([]);
    checked: boolean = true;
    dataSource = new MatTableDataSource<BillingAdjustmentDetails>([]);

statusFilter: string = '';
dateForm: FormGroup;
// Custom Error State Matcher (for consistent error state handling)
matcher = new DateRangeErrorStateMatcher();
  startDateInvalid: boolean = false;
  endDateInvalid: boolean = false;
  invoiceDisplayedColumnKeys = this.invoiceDisplayedColumns.map(c => c.propertyName);
  panels: any[] = [];
   pageSize: number = 10; 
   totalCount: number = 0;
   currentPageIndex: number = 1; 
   currentAppliedFilters: FilterDto[] = []; 
   currentStartDate: string | null = null; 
   currentEndDate: string | null = null; 
   currentStatusId: string = '0'; 

    constructor(
      private approvalDashBoardService: ApprovalDashBoardService,
      private authService: AuthService,
      private toastr: ToastrService,private spinner: SpinnerService, 
      private fb: FormBuilder,
      private msalService: MsalService,
      private digitalCopyPdfService: DigitalCopyPdfService
    ) { }
  
    ngOnInit(): void {


      this.dateForm = this.fb.group({
        startDate: null,
        endDate: null,
        statusFilter: ['0'] 
      }, { validator: dateRangeValidator });
    
  
      // Watch form value changes to trigger validation and data filtering
      this.dateForm.valueChanges.subscribe(() => {
        this.validateDateRange();
       // this.filterData();
      });
        this.onSubmit(1,10);
    }
    isDateRangeInvalid(): boolean {
      return this.dateForm.hasError('dateRangeInvalid');
    }
  
     
filterData() {
  let statusval;
  
 if (this.dateForm.get('statusFilter')?.value === 'all') {
  statusval = null;
} else {
  statusval = this.dateForm.get('statusFilter')?.value;
}

  // Start with the original data (to reset the filter)
  let filteredData = this.respose;  // Make sure to reset filteredData to the original 

  // Convert startDate and endDate to Date objects (if they exist)
  const start = this.dateForm.get('startDate')?.value ? new Date(this.dateForm.get('startDate')?.value) : null;
  const end = this.dateForm.get('endDate')?.value ? new Date(this.dateForm.get('endDate')?.value) : null;


  // If the dates are valid, filter the data
  if (start && end && !this.startDateInvalid && !this.endDateInvalid) {
    filteredData = filteredData.filter(item => {
      const adjRequestDate = new Date(item.adjRequestDate);  // Assuming 'adjRequestDate' is the date field
      return adjRequestDate >= start && adjRequestDate <= end;
    });
  }


  // Filter by status if statusval is defined (not null)
  if (statusval) {
    filteredData = filteredData.filter(item => 
      item.statusDesc.toLowerCase() === statusval.toLowerCase()
    );
  }

  // If no filters are applied, reset the filteredData to show all data
  if (!start && !end && !statusval) {
    filteredData = this.respose; // Reset to the original data if no filters are applied
  }

  // Apply the filtered data back to the data source
  this.dataSource.data = filteredData;
}

 // Triggered when start date changes
 onStartDateChange() {
  this.validateDateRange();
  this.filterData();  // Apply filter after validation
}

// Triggered when end date changes
onEndDateChange() {
  this.validateDateRange();
  this.filterData();  // Apply filter after validation
}

// Date range validation logic
validateDateRange() {
  const startDate = this.dateForm.get('startDate')?.value;
  const endDate = this.dateForm.get('endDate')?.value;

  // Reset error flags before validation
  this.startDateInvalid = false;
  this.endDateInvalid = false;

   // Validate if startDate is after endDate
   if (startDate && endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (start > end) {
      this.startDateInvalid = true;
      this.endDateInvalid = true;
      console.log('Validation failed: Start Date is greater than End Date');
    }
  }
}
displayedColumnsList() : any[] {
return this.isGoodWillRequest ? this.invoiceDisplayedGoodWillColumns :  this.invoiceDisplayedColumns
}

    openViewInvoiceDialog(e) {
      this.selectedData = e.details;
      if(this.selectedData.adjReason === "Goodwill"){
        this.isGoodWillRequest = true;
        this.invoiceDisplayedColumnKeys = this.invoiceDisplayedGoodWillColumns.map(c => c.propertyName);
      }else{
        this.isGoodWillRequest = false;
        this.invoiceDisplayedColumnKeys = this.invoiceDisplayedColumns.map(c => c.propertyName);
      }
       if (e.callFrom === 'download') {
        if(e.details.isFileUploaded)
          {
        this.spinner.showSpinner();
        this.approvalDashBoardService.DownloadUploadedFiles(e.details.adjReqId)
          .subscribe({
            next: data => {
              const filename = `AdjustmentRequest_${e.details.adjReqId}.zip`;  
              const blob = new Blob([data], { type: 'application/zip' });
              saveAs(blob, filename);
              this.spinner.hideSpinner();
              this.toastr.success('File Downloaded Successfully', 'Success');
            },
            error: () => {
              this.spinner.hideSpinner();
              this.toastr.error('Error downloading file', 'Error');
            }
          });
      }
      else{
        this.toastr.warning('No Files Uploaded', 'warning');
      }
    }
    else if (e.callFrom === 'digital-copy-pdf') {
      // Handle digital copy PDF download
      this.downloadDigitalCopy(e.details.adjReqId);
    }
   
    }
  
    closePopup() {
      if (this.dialogRef) {
        this.dialogRef.hide();
      }
    }

    formatDate(date: Date, isEndDate: boolean = false): string {
      if (!date) return null;
      const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
      if (isEndDate) {
        utcDate.setUTCHours(23, 59, 59, 999);
      } else {
        utcDate.setUTCHours(0, 0, 0, 0);
      }
      return utcDate.toISOString();
    }
    
    onSubmit(pageIndex: number = 1, pageSize: number = 10, filters: FilterDto[] = [], isRefresh: boolean = false){
      
      this.spinner.showSpinner();
      
      if (isRefresh) {
        pageIndex = 1;
        pageSize = 10;
        this.pageSize = 10;
        this.currentAppliedFilters = [];
        this.currentStartDate = null;
        this.currentEndDate = null;
        this.currentStatusId = '0';
        this.dateForm.patchValue({ 
          startDate: null, 
          endDate: null, 
          statusFilter: '0' 
        });
        filters = [];
      }
      
      const isFilterChange = filters.length > 0;
      const isPaginationChange = filters.length === 0 && !isRefresh;
      
      
      if (isPaginationChange && this.currentAppliedFilters.length > 0) {
        filters = [...this.currentAppliedFilters];
      }
      
      if (isFilterChange) {
        pageIndex = 1;
        this.currentAppliedFilters = [...filters];
      }
      

      if (!isPaginationChange || this.currentStartDate === null) {
        const startDate = this.dateForm.get('startDate')?.value;
        const endDate = this.dateForm.get('endDate')?.value;
        this.currentStartDate = this.formatDate(startDate);
        this.currentEndDate = this.formatDate(endDate, true);
        this.currentStatusId = this.dateForm.get('statusFilter')?.value;
      }

     let obj : any ={
        CloudId: this.msalService.instance.getActiveAccount().username.toString(),
        StartDate : this.currentStartDate,
        EndDate: this.currentEndDate,
        StatusId: this.currentStatusId,
        PageNumber: pageIndex,                     
        PageSize: pageSize,  
        filters: filters.map(f => ({
          column: f.column,
          operator : f.operator || 'contains',
          value: f.value?.toString() || '', 
    })) 
      }

      
      this.approvalDashBoardService.getBillingAdjustmentsByCloudIdDateRange( obj).subscribe({
        next: response => {
          
          const data = response.billingAdjustmentResponse || [];
          this.dataSource = new MatTableDataSource(data);
          this.totalCount = response.totalCount || response.TotalCount || data.length;
          this.pageSize = pageSize;
          this.currentPageIndex = pageIndex;
          
          this.dataSource.data.forEach(x => {
            x.adjRequestDate = formatDate(x.adjRequestDate,'MM/dd/yyyy', "en-US");     
            x.statusDesc = BillingAdjustmentStatusEnumDisplay[x.statusId]
          });
          
          
          this.isLoader = false;
          this.spinner.hideSpinner();
          
          this.updatePaginatorState();
        },
        error: () => {
          this.spinner.hideSpinner();
        }
      })
  }

  // Update paginator state to sync with current page
  private updatePaginatorState() {
    setTimeout(() => {
      if (this.dynamicTable && this.dynamicTable.paginator) {
        const paginatorPageIndex = Math.max(0, this.currentPageIndex - 1);
        
        this.dynamicTable.paginator.length = this.totalCount;
        this.dynamicTable.paginator.pageSize = this.pageSize;
        this.dynamicTable.paginator.pageIndex = paginatorPageIndex;
        
        const maxPages = Math.ceil(this.totalCount / this.pageSize);
        

      } else {
        console.warn('Approval History: Paginator not available for state update');
      }
    }, 0);
  }

    showTooltip = false;
    tooltipSvg = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="200" height="200">
      <text x="10" y="20" class="tooltip-text">$0 - $2,499:  Supervisor</text><br/>
      <text x="10" y="40" class="tooltip-text">$0 - $4,999:  Manager</text><br/>
      <text x="10" y="60" class="tooltip-text">$0 & above:  District Mgr/ Finance Director</text><br/>
      <text x="10" y="80" class="tooltip-text">Any amount of goodwill request: Requires approval from MI Director of Finance</text>
    </svg>
  `;
}

